import Vue from 'vue'
import Router from 'vue-router'
import Tracker from '../Tracker'
import AdminSummary from '../AdminSummary'
import AdminFilter from '../AdminFilter'
import AdminCreate from '../AdminCreate'
import AdminEdit from '../AdminEdit'

import navbar from '../components/Navbar.vue'
import Login from '../components/Login'
import firebase from 'firebase'
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('datetime', Datetime);

Vue.use(Router)
Vue.use(require('vue-moment'));
Vue.component('navbar', navbar);

firebase.initializeApp({
    apiKey: "AIzaSyAPgJKiuCrO9CxO1981G_cNS6LaZtAxfdg",                             // Auth / General Use
    appId: "834183445727",      // General Use
    projectId: "timer-38d05",               // General Use
    authDomain: "YOUR_APP.firebaseapp.com",         // Auth with popup/redirect
    databaseURL: "https://timer-38d05.firebaseio.com/", // Realtime Database
    storageBucket: "YOUR_APP.appspot.com",          // Storage
    messagingSenderId: "123456789",                  // Cloud Messaging
    measurementId: "G-12345"                        // Analytics
    });

  
export default new Router({
  routes: [
    {
        path : '/',
        name : 'home',
        component: Login
    },
    {
        path : '/login',
        name : 'login',
        component: Login
    },
    {
      path: '/tracker',
      name: 'Tracker',
      component: Tracker
    },
    {
      path: '/admin-filter',
      name: 'AdminFilter',
      component: AdminFilter
    },
    {
      path: '/admin-summary',
      name: 'Admin',
      component: AdminSummary
    },
    {
      path: '/admin-create',
      name: 'AdminCreate',
      component: AdminCreate
    },
    {
      path: '/admin-edit',
      name: 'AdminEdit',
      component: AdminEdit
    }
  ]
})
